import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationControl = createCrudVuexModule({
  namespaced: true,
  path: "/audit-control/control",
  moduleName: "organizationControl",
  options: {
    localizedFields: ["name", "description", "manager", "riskNote", "goal", "approval.note", "relatedStandards"],
  },
  state: {
    activeTab: "ORGANIZATION_CONTROLS",
    activeSubTab: "EVALUATION_PENDING",
    isDownloading: false,
    showFilterSidebar: false,
    controlFilters: {
      no: "",
      name: "",
      category: null,
      criticalities: [],
      type: null,
      compliance: "",
      complianceGroup: null,
      complianceItemNo: "",
      complianceItemSearch: "",
      complianceItemDescription: "",
      status: undefined,
    },
  },
  getters: {
    activeTab: (state) => state.activeTab,
    activeSubTab: (state) => state.activeSubTab,
    isDownloading: (state) => state.isDownloading,
    showFilterSidebar: (state) => state.showFilterSidebar,
    controlFilters: (state) => state.controlFilters,
  },
  mutations: {
    activeTab: (state, value) => (state.activeTab = value),
    activeSubTab: (state, value) => (state.activeSubTab = value),
    isDownloading: (state, value) => (state.isDownloading = value),
    showFilterSidebar: (state, value) => {
      if (state.showFilterSidebar !== value) {
        state.showFilterSidebar = value;
        state.controlFilters = {
          no: "",
          name: "",
          category: null,
          criticalities: [],
          type: null,
          compliance: "",
          complianceGroup: null,
          complianceItemNo: "",
          complianceItemSearch: "",
          complianceItemDescription: "",
          status: undefined,
        };
      }
    },
    controlFilters: (state, value) => (state.controlFilters = value),
  },
  actions: {
    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/audit-control/control/download", payload);
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
    async approve({ commit }, payload) {
      try {
        const response = await rest.post("/audit-control/control/approve", payload);
        return response;
      } finally {
      }
    },
    async reject({ commit }, payload) {
      try {
        const response = await rest.post("/audit-control/control/reject", payload);
        return response;
      } finally {
      }
    },
    async cancel({ commit }, payload) {
      try {
        const response = await rest.post("/audit-control/control/cancel", payload);
        return response;
      } finally {
      }
    },
    async passive({ commit }, payload) {
      try {
        const response = await rest.post("/audit-control/control/passive", payload);
        return response;
      } finally {
      }
    },
    async active({ commit }, payload) {
      try {
        const response = await rest.post("/audit-control/control/active", payload);
        return response;
      } finally {
      }
    },

    async fetchFilteredControls({ state }, { query = {}, options = {} }) {
      const f = state.controlFilters;
      const finalQuery = { ...query };

      // Helper to add filter if value exists
      const add = (key, val) => {
        if (val && (Array.isArray(val) ? val.length > 0 : true)) {
          finalQuery[key] = { value: val, isObject: true };
          // For 'name', simple value might be enough if backend handles it, but consistency is safe.
        }
      };

      add("no", f.no);
      add("name", f.name);
      if (f.category) {
        const val = f.category._id || f.category;
        finalQuery.category = { value: val, isObject: true };
      }
      if (f.criticalities && f.criticalities.length) finalQuery.criticality = { value: f.criticalities, isObject: true };
      if (f.type) {
        const val = f.type._id || f.type;
        finalQuery.type = { value: val, isObject: true };
      }

      add("compliance", f.compliance);
      if (f.complianceGroup) {
        const val = f.complianceGroup._id || f.complianceGroup;
        finalQuery.complianceGroup = { value: val, isObject: true };
      }

      if (f.complianceItemNo) {
        const val = f.complianceItemNo.name ? f.complianceItemNo.name.tr || f.complianceItemNo.name.en || f.complianceItemNo.name : f.complianceItemNo;
        if (val) finalQuery.complianceItemNo = { value: val, isObject: true };
      }
      add("complianceItemSearch", f.complianceItemSearch);
      add("complianceItemDescription", f.complianceItemDescription);
      add("status", f.status);

      const response = await rest.post("/audit-control/control/detailed-paginate", { pagination: { query: finalQuery, options } });
      return response;
    },
  },
});
